import React, { memo, PropsWithChildren } from 'react';

type BaseScreenComponentProps = PropsWithChildren<{
  item: any;
  className?: string;
  fullClassName?: string;
}>;

const BasePerformanceComponent = memo(({
  item, children, className, fullClassName
}: BaseScreenComponentProps) => {
  return (
    <div className={fullClassName || `Screen__Component__Question ${className || ''}`}>
      <div className="Screen__Component__Question__Text !tw-break-words tw-overflow-wrap-anywhere">
        { item.settings.text }
        {
          item.settings.answer_required && (
            <span className="Screen__Component__Question__Text__Required">
              *
            </span>
          )
        }
      </div>
      {
        item.settings.description && (
          <div className="Screen__Component__Question__Description !tw-break-words tw-overflow-wrap-anywhere">
            { item.settings.description }
          </div>
        )
      }
      { children }
    </div>
  );
});

export default BasePerformanceComponent;
